import react, { useEffect } from 'react';
import { CloseGreyIcon, FireWhiteIcon, GlutenFreeBlackIcon, MuscleIcon, SugarFreeWhiteIcon, VeganWhiteIcon } from '../../../assets/icons';
import { Switch } from '@mui/material';
import { motion } from 'framer-motion';
import { MenuFilter } from '../../../utils/clientMenu';

interface FiltersViewProps {
    primaryColor?: string;
    filter: MenuFilter;
    setFilters: (filters: MenuFilter) => void;
    onClose: () => void;
}

const FiltersView: React.FC<FiltersViewProps> = ({ onClose, filter, setFilters, primaryColor }) => {

    const resetFilters = () => {
        setFilters({
            searchText: "",
            selectedTags: [],
            minPrice: "",
            maxPrice: "",
            onlyNew: false,
            onlyWithImage: false,
            allItems: false,
        });
    }

    return (
        <section className="modal-section filter-products" onClick={onClose}>
            <div className="w-layout-blockcontainer container w-container">
                <motion.section
                    initial={{ opacity: 0, scale: 0.96, y: 12 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.96, y: 12 }}
                    transition={{ duration: 0.2 }}
                    style={{}}
                >
                    <div className="modal-wrapper">
                        <div className="modal-div" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-header-div">
                                <div>
                                    <div className="modal-header">Filtriraj proizvode</div>
                                    <div className="description-text">
                                        Filteri će prikazati rezultat primenjen na sve stavke menija<br />
                                    </div>
                                </div>
                                <div className="modal-button-div" onClick={() => {
                                    resetFilters();
                                    onClose();
                                }}>
                                    <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                                </div>
                            </div>
                            <div className="modal-form-block w-form">
                                <form id="wf-form-" className="modal-form">
                                    <div className="modal-form-div-group">
                                        {/* <div className="modal-checkbox-list">
                                            <div className="small-box-div pointer"
                                                onClick={() => setFilters({ ...filter, allItems: !filter.allItems })}
                                            >
                                                <div>Primeni filtere na sve stavke</div>
                                            </div>
                                        </div> */}
                                        <div className="modal-form-div">
                                            <label className="modal-form-label">Pretraga po tekstu</label>
                                            <input className="form-input grey w-input" placeholder="Naziv ili opis..." type="text"
                                                value={filter.searchText}
                                                onChange={(e) => setFilters({ ...filter, searchText: e.target.value })}
                                            />
                                        </div>
                                        <div className="modal-form-div">
                                            <label className="modal-form-label">Tagovi</label>
                                            {/* <div className="modal-tags-div">
                                                <div className="small-box-div wide pointer light-green-bg">
                                                    <div>Ljuto</div>
                                                </div>
                                                <div className="small-box-div wide pointer">
                                                    <div>Ljuto</div>
                                                </div>
                                            </div> */}
                                            <div className="client-product-tags-list-div">

                                                <div className="div-block-89"
                                                    onClick={() => {
                                                        const selectedTags = filter.selectedTags.includes("protein") ?
                                                            filter.selectedTags.filter(tag => tag !== "protein") :
                                                            [...filter.selectedTags, "protein"];
                                                        setFilters({ ...filter, selectedTags });
                                                    }}
                                                >
                                                    <div className="small-box-div turquoise-bg">
                                                        <img src={MuscleIcon} loading="lazy" alt="" className="icon-size-16" />
                                                        <div>Protein</div>
                                                    </div>
                                                    {!filter.selectedTags.includes("protein") &&
                                                        < div className="div-block-90"></div>
                                                    }
                                                </div>

                                                <div className="div-block-89"
                                                    onClick={() => {
                                                        const selectedTags = filter.selectedTags.includes("gluten-free") ?
                                                            filter.selectedTags.filter(tag => tag != "gluten-free") :
                                                            [...filter.selectedTags, "gluten-free"];
                                                        setFilters({ ...filter, selectedTags })
                                                    }}
                                                >
                                                    <div className="small-box-div orange-bg">
                                                        <img src={GlutenFreeBlackIcon} loading="lazy" alt="" className="icon-size-16" />
                                                        <div>Gluten free</div>
                                                    </div>
                                                    {!filter.selectedTags.includes("gluten-free") &&
                                                        <div className="div-block-90"></div>
                                                    }
                                                </div>

                                                <div className="div-block-89"
                                                    onClick={() => {
                                                        const selectedTags = filter.selectedTags.includes("vegan") ?
                                                            filter.selectedTags.filter(tag => tag !== "vegan") :
                                                            [...filter.selectedTags, "vegan"]
                                                        setFilters({ ...filter, selectedTags })
                                                    }}
                                                >
                                                    <div className="small-box-div dark-green-bg">
                                                        <img src={VeganWhiteIcon} loading="lazy" alt="" className="icon-size-16" />
                                                        <div>Vegan</div>
                                                    </div>
                                                    {!filter.selectedTags.includes("vegan") &&
                                                        <div className="div-block-90"></div>
                                                    }
                                                </div>

                                                <div className="div-block-89"
                                                    onClick={() => {
                                                        const selectedTags = filter.selectedTags.includes("spicy") ?
                                                            filter.selectedTags.filter(tag => tag !== "spicy") :
                                                            [...filter.selectedTags, "spicy"]
                                                        setFilters({ ...filter, selectedTags })
                                                    }}
                                                >
                                                    <div className="small-box-div red-spicy">
                                                        <img src={FireWhiteIcon} loading="lazy" alt="" className="icon-size-16" />
                                                        <div>Spicy</div>
                                                    </div>
                                                    {!filter.selectedTags.includes("spicy") &&
                                                        <div className="div-block-90"></div>
                                                    }
                                                </div>

                                                <div className="div-block-89"
                                                    onClick={() => {
                                                        const selectedTags = filter.selectedTags.includes("sugar-free") ?
                                                            filter.selectedTags.filter(tag => tag !== "sugar-free") :
                                                            [...filter.selectedTags, "sugar-free"]
                                                        setFilters({ ...filter, selectedTags })
                                                    }}
                                                >
                                                    <div className="small-box-div green-sugar-free">
                                                        <img src={SugarFreeWhiteIcon} loading="lazy" alt="" className="icon-size-16" />
                                                        <div>Sugar free</div>
                                                    </div>
                                                    {!filter.selectedTags.includes("sugar-free") &&
                                                        <div className="div-block-90"></div>
                                                    }
                                                </div>

                                            </div>

                                        </div>
                                        <div className="div-grid-2">
                                            <div className="modal-form-div">
                                                <label className="modal-form-label">Opseg cena</label>
                                                <input className="form-input grey w-input" placeholder="Min" type="number" min={0}
                                                    onChange={(e) => { setFilters({ ...filter, minPrice: e.target.value }) }}
                                                    value={filter.minPrice}
                                                />
                                            </div>
                                            <div id="w-node-fabffad8-c778-fa18-9dc2-ba605ef69955-d5e61be0" className="modal-form-div">
                                                <input className="form-input grey w-input" placeholder="Max" type="number" min={0}
                                                    style={{ "marginTop": "auto" }}
                                                    onChange={(e) => { setFilters({ ...filter, maxPrice: e.target.value }) }}
                                                    value={filter.maxPrice} />
                                            </div>
                                        </div>
                                        <div className="modal-form-div">
                                            <div className="modal-checkbox-list">
                                                <div className={`small-box-div pointer wide ${filter.onlyNew ? "light-green-bg" : ""}`}
                                                    onClick={() => setFilters({ ...filter, onlyNew: !filter.onlyNew })}
                                                >
                                                    <div>Samo novi proizvodi</div>
                                                </div>
                                                <div className={`small-box-div pointer wide ${filter.onlyWithImage ? "light-green-bg" : ""}`}
                                                    onClick={() => setFilters({ ...filter, onlyWithImage: !filter.onlyWithImage })}
                                                >
                                                    <div>Samo sa slikom</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-form-div f-horizontal">
                                            <label className="modal-form-label">Primeni filtere na sve stavke</label>
                                            <Switch
                                                checked={filter.allItems}
                                                onChange={() => setFilters({ ...filter, allItems: !filter.allItems })}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-buttons">
                                <div className="button-secondary medium" onClick={() => {
                                    resetFilters();
                                    onClose();
                                }}>
                                    <div>Restartuj</div>
                                </div>
                                <div className="button-primary medium client-gold" style={{ backgroundImage: `linear-gradient(0deg, ${primaryColor}, ${primaryColor}cc)`, color: "white" }}
                                    onClick={onClose}
                                >
                                    <div>Filtriraj</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section >
            </div >
        </section >

    );
};

export default FiltersView;

